import { useEffect } from 'react';

const useKeyHandler = ({ active = true, callback, keyCode, keyEvent }) => {
  useEffect(() => {
    const handler = (e) => {
      if (e.keyCode === keyCode) {
        callback();
      }
    };
    if (active) {
      window.addEventListener(keyEvent, handler);
    }

    return () => window.removeEventListener(keyEvent, handler);
  }, [callback, keyEvent, keyCode, active]);
};

export default useKeyHandler;
